module.exports = __webpack_public_path__ + "media/media/about/tawinc-ae22321b6eb2e6c078e6347545f186bd.jpg";